export default __webpack_public_path__ + "4527de3c6a537600b1e11d8ba62d78fd.png";